import { configureStore } from '@reduxjs/toolkit'
import { ENV } from '@/config'
import { rootReducer } from './rootReducer'

/**
 * Redux store — used for global UI state only.
 * Server data (API responses) lives in TanStack Query, NOT here.
 *
 * What belongs in Redux:
 *   ✅ Auth session (user object, role, isAuthenticated)
 *   ✅ UI state (sidebar open/closed, theme, notifications)
 *   ✅ App-wide preferences
 *
 * What does NOT belong in Redux:
 *   ❌ API response data → use TanStack Query
 *   ❌ Form state → use Formik
 *   ❌ Local component state → use useState
 */
export const store = configureStore({
  reducer: rootReducer,
  devTools: ENV.FLAGS.REDUX_DEVTOOLS,
})

// Infer types from store itself — always in sync with reducers
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
